/* PawChibi 共用外壳脚本（2026-09-23）：手机菜单开合 / 公告条关闭与订阅 / 购物车件数 */
(function(){
  'use strict';
  var $=function(s){return document.querySelector(s);};

  /* 手机菜单 */
  var toggle=$('#pcs-menu-toggle'),menu=$('#pcs-mobile-menu');
  if(toggle&&menu){
    var setOpen=function(open){menu.hidden=!open;toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Close navigation menu':'Open navigation menu');};
    toggle.addEventListener('click',function(){setOpen(menu.hidden);});
    menu.addEventListener('click',function(e){if(e.target.closest('a'))setOpen(false);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!menu.hidden)setOpen(false);});
  }

  /* 公告条：关闭记住本次访问；点文字或按钮弹订阅框（Klaviyo） */
  var bar=$('[data-pcs-announce]');
  if(bar){
    var close=bar.querySelector('[data-pcs-announce-close]');
    if(close)close.addEventListener('click',function(){bar.hidden=true;try{sessionStorage.setItem('pcs-announce-closed','1');}catch(e){}});
    bar.querySelectorAll('[data-pcs-signup]').forEach(function(b){b.addEventListener('click',function(){
      var opened=false;
      /* 电脑＝居中弹窗 WRM99d；手机＝底部抽屉 UVuE2j（Klaviyo 两个表单，2026-09-23 方案 A） */
      var formId=(window.matchMedia&&window.matchMedia('(hover:none)').matches)?'UVuE2j':'WRM99d';
      try{if(window._klOnsite&&typeof window._klOnsite.openForm==='function'){window._klOnsite.openForm(formId);opened=true;}
      else{window._klOnsite=window._klOnsite||[];window._klOnsite.push(['openForm',formId]);opened=true;}}catch(e){}
      if(!opened){var f=$('#stay-close');if(f)f.scrollIntoView({behavior:'smooth'});else location.href='/#stay-close';}
    });});
  }

  /* 购物车件数：进页拿一次，从别的页返回（含后退缓存）再拿一次 */
  var count=$('[data-pcs-cart-count]');
  function syncCart(){
    if(!count)return;
    fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(c){
      if(!c)return;var n=(c.items||[]).filter(function(i){return i.handle!=='rush-creation-1-week';}).length; /* 只数宠物件数，加急 Rush 不算一件（与购物车标题一致） */count.textContent=String(n);count.hidden=n===0;
    }).catch(function(){});
  }
  syncCart();
  window.addEventListener('pageshow',function(e){if(e.persisted)syncCart();});
  window.addEventListener('paw-cart-change',syncCart); /* 购物车页里删件、改加急后角标跟着变（原来要刷新才变） */
  document.addEventListener('pcs:cart-updated',syncCart);
})();

/* ===== 全站滚动淡入上移（A 包 2026-09-26 Austin 拍板，学 Oura：1 秒、只播一次、开「减少动态效果」不动）=====
   规则：只处理 <main> 里首屏以下的内容块；一段只有一个包装层时往里找一层，直到找到并排的几块；高过 0.9 屏的块不整体淡入；
   含吸顶/固定元素的块不动（transform 会打断吸顶）；播完把类名摘掉，页面回到原样。
   让路：页面自带淡入的块（带 data-reveal，或一开始就透明/已位移）不碰；状态类名只用 pc-rv / pc-rv-in，
   绝不用 is-in（Shop All、How it works 等页自己的动画用 is-in，摘掉会让它们退回透明或空条，09-26 上线当天实测撞过）。 */
(()=>{
 if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const run=()=>{
  const main=document.querySelector('main');if(!main)return;
  const vh=innerHeight,units=[];
  const stickies=[...main.querySelectorAll('*')].filter(e=>{const p=getComputedStyle(e).position;return p==='sticky'||p==='fixed';});
  const ok=k=>k.offsetHeight>0&&!/^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(k.tagName);
  const owned=k=>{if(k.matches('[data-reveal]')||k.querySelector('[data-reveal]'))return true;const s=getComputedStyle(k);return parseFloat(s.opacity)<1||s.transform!=='none';};
  const pick=(el,depth)=>{
   if(el.matches('[data-reveal]'))return;
   const kids=[...el.children].filter(ok);if(!kids.length)return;
   if(kids.length===1&&depth<3){pick(kids[0],depth+1);return;}
   // 一排都是小件（导航条、锚点行、标签行）：整排当一块，不逐个闪
   if(kids.length>1&&Math.max(...kids.map(k=>k.getBoundingClientRect().height))<80){const r=el.getBoundingClientRect();if(r.top>=vh*0.92&&r.height<vh*0.9&&!stickies.some(s=>el.contains(s))&&!owned(el)){units.push(el);}return;}
   kids.forEach((k,i)=>{
    const r=k.getBoundingClientRect();
    if(r.top<vh*0.92||r.height<24)return;        // 首屏里的不藏（避免一开就闪）；太矮的小件不藏
    if(r.height>vh*0.9){if(depth<3)pick(k,depth+1);return;}
    if(stickies.some(s=>k.contains(s))||owned(k))return;
    k.style.transitionDelay=Math.min(i,3)*90+'ms';units.push(k);
   });
  };
  [...main.children].filter(ok).forEach(k=>pick(k,0));
  if(!units.length)return;
  units.forEach(u=>u.classList.add('pc-rv'));
  const done=u=>{u.classList.remove('pc-rv','pc-rv-in');u.style.transitionDelay='';};
  const io=new IntersectionObserver(es=>{es.forEach(e=>{if(!e.isIntersecting)return;const u=e.target;io.unobserve(u);
   requestAnimationFrame(()=>{u.classList.add('pc-rv-in');u.addEventListener('transitionend',ev=>{if(ev.target===u)done(u);});setTimeout(()=>done(u),1500);});});},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
  units.forEach(u=>io.observe(u));
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
